/**
 * Component to render children only on client side
 *
 * <CSR>
 *  <ComponentThatCantBeSSR />
 * </CSR>
 *
 * The difference between this component and `next/dynamic` is that this
 * will include the component in the bundle, while `next/dynamic` will
 * create a separate bundle and load it dynamically.
 */

import { useState, useEffect, type ReactNode } from 'react'

export const CSR = ({ children }: { children: ReactNode }) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  return mounted ? <>{children}</> : <></>
}
